const contentStore = {
  state : {
    contentList : []
  },
  getters: {
    getContentList(state) {
      return state.contentList
    }
  },
  mutations : {
    setContentList(state, param) {
      state.contentList = param
    }
  }
}
export default contentStore